import { render } from "./ContactGroups.vue?vue&type=template&id=31854143&scoped=true"
import script from "./ContactGroups.vue?vue&type=script&lang=js"
export * from "./ContactGroups.vue?vue&type=script&lang=js"

import "./ContactGroups.vue?vue&type=style&index=0&id=31854143&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31854143"]])

export default __exports__